import React, { useEffect, useState } from 'react';
import { motion, useScroll, useTransform, AnimatePresence } from 'framer-motion';
import CosmicBackground from '../components/CosmicBackground';

const Testimonials = () => {
  const [scrollY, setScrollY] = useState(0);
  const [currentCardSet, setCurrentCardSet] = useState(0);
  const { scrollYProgress } = useScroll();
  
  const y1 = useTransform(scrollYProgress, [0, 1], [0, -30]);
  const y2 = useTransform(scrollYProgress, [0, 1], [0, -60]);

  useEffect(() => {
    const handleScroll = () => setScrollY(window.scrollY);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const testimonials = [
    {
      name: "Abhik Bhattacharya",
      profession: "Engineer, ISRO",
      content: "I was very convinced with the logical ways in which she connected our life events and actions with Astrology and consulted us. Avantika Ji is not only a capable Astrologer who will offer deep and valuable insights about your chart, but also an extremely amiable soul who radiates hope & positivity.",
      image: "/Abhik.png",
      zodiacSign: "♐",
      zodiacName: "Sagittarius",
      element: "fire",
      gradient: "from-purple-500 via-pink-500 to-red-500",
      stars: 5
    },
    {
      name: "Chandini",
      profession: "Media Professional",
      content: "I consulted Astrohelp to know about my career sometime back. Right help from the right source always works for the better. Thank you for the powerful reading!",
      image: "/client_4.jpg",
      zodiacSign: "♌",
      zodiacName: "Leo",
      element: "fire",
      gradient: "from-orange-400 via-red-500 to-yellow-500",
      stars: 5
    },
    {
      name: "Gyan",
      profession: "Business Professional", 
      content: "Legal affairs are tricky, but can be dealt with wisdom and patience - I remember this was the exact thing you told me during our interaction. Thank god what you said and evaluated was true and I came out clean of my issue with god's grace and your suggestions",
      image: "/client_1.jpg",
      zodiacSign: "♎",
      zodiacName: "Libra",
      element: "air",
      gradient: "from-blue-300 via-purple-300 to-pink-300",
      stars: 5
    },
    {
      name: "Snehil",
      profession: "CEO @ Spotdefence",
      content: "I remember having reached out to you, when I was messing up with my relationship. It became an easy phase, since you made me look into the logics and facts which were so profound and real. Thankful to your deep work and suggested remedies. It actually worked",
      image: "/client_2.jpg",
      zodiacSign: "♏",
      zodiacName: "Scorpio",
      element: "water",
      gradient: "from-indigo-600 via-purple-600 to-blue-800",
      stars: 5
    },
    {
      name: "Shruti",
      profession: "HR Professional",
      content: "I never really believed in astrology, but the work of this young astrologer pushed me far ahead, by revealing facts about myself. Thanks a lot.",
      image: "/client_3.jpg",
      zodiacSign: "♍",
      zodiacName: "Virgo",
      element: "earth",
      gradient: "from-green-500 via-emerald-600 to-teal-700",
      stars: 5
    },
    {
      name: "Vrica Vij",
      profession: "Counsellor",
      content: "She not only told me confidently about my future occurrences but also gave me a fair assessment of my personality traits that were spot on, which really surprised me because there is no way she could have known who I am accurately after only a five minute phone conversation. She doesn't sugarcoat what she reads in the chart and tells it the way it is, which I appreciate because it makes me trust her.",
      image: "/client_5.jpg",
      zodiacSign: "♋",
      zodiacName: "Cancer",
      element: "water",
      gradient: "from-cyan-400 via-blue-500 to-indigo-600",
      stars: 5
    },
    {
      name: "Akshay Ray",
      profession: "Corporate Professional, Fiat India Automobiles",
      content: "The best part about her is that she tries to hear your concerns fully and then guides you in the best path without the use of any costly remedies. As people say a good guide is the most important to tread a difficult path. Ma'am is surely an example of such. I thank her immensely for helping me in my tough times!",
      image: "/client_6.jpg",
      zodiacSign: "♈",
      zodiacName: "Aries",
      element: "fire",
      gradient: "from-red-500 via-orange-500 to-yellow-400",
      stars: 5
    },
    // New testimonials
    {
      name: "Anjana Kumar",
      profession: "Taiwan",
      content: "I consulted Avantika regarding my marriage and compatibility. She is very meticulous and explained every aspect in the horoscope. She is also relatable and helped me understand things in detail as she analyses things closely and from the depth. Her approach towards astrology is very practical. She is very resourceful and has always offered a great astrological guidance.",
      image: "/Anjana.png",
      zodiacSign: "♉",
      zodiacName: "Taurus",
      element: "earth",
      gradient: "from-amber-600 via-yellow-700 to-orange-800",
      stars: 5
    },
    {
      name: "Sayun Pomoung",
      profession: "PGDA, Archaeological Survey Of India",
      content: "Really loved the consultation with you. It was extremely informative and helpful in the sense of clearing multiple doubts, which I had regarding my career path and moves. Thank you for your clear analysis, wonderful insights and guidance.",
      image: "/Sayun.png",
      zodiacSign: "♊",
      zodiacName: "Gemini",
      element: "air",
      gradient: "from-yellow-300 via-green-300 to-blue-300",
      stars: 5
    },
    {
      name: "Uma",
      profession: "Doctor, United States",
      content: "I am so happy to find Avantika on Instagram. This was my first time reading with her and I am very happy with my reading. She is very knowledgeable and accurate. She gave me directions and insights I needed to navigate through my uncertainty. She also provided with remedies for my situation. Thank you Avantika!",
      image: "/Uma.png",
      zodiacSign: "♒",
      zodiacName: "Aquarius",
      element: "air",
      gradient: "from-teal-400 via-cyan-500 to-blue-600",
      stars: 5
    }
  ];

  // Auto-shuffle cards every 15 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentCardSet(prev => (prev + 1) % Math.ceil(testimonials.length / 3));
    }, 15000);

    return () => clearInterval(interval);
  }, [testimonials.length]);

  // Get current 3 cards to display
  const getCurrentCards = () => {
    const startIndex = currentCardSet * 3;
    const currentCards = [];
    
    for (let i = 0; i < 3; i++) {
      const index = (startIndex + i) % testimonials.length;
      currentCards.push({ ...testimonials[index], displayIndex: i });
    }
    
    return currentCards;
  };

  const currentCards = getCurrentCards();

  return (
    <CosmicBackground>
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.2 }}
        className="min-h-screen relative z-10"
      >
        <div className="pt-32 pb-20">
          <div className="max-w-6xl mx-auto px-4">
            
            {/* Header */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1 }}
              className="text-center mb-16"
            >
              <motion.h1
                className="text-5xl md:text-6xl font-bold mb-6 bg-gradient-to-r from-yellow-300 via-yellow-200 to-yellow-300 bg-clip-text text-transparent leading-tight py-2"
                animate={{
                  backgroundPosition: ["0% 50%", "100% 50%", "0% 50%"],
                }}
                transition={{
                  duration: 5,
                  repeat: Infinity,
                }}
                style={{
                  backgroundSize: "200% 200%",
                }}
              >
                What Our Clients Say
              </motion.h1>
              <p className="text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed mb-8">
                Real experiences from people who found clarity and direction through cosmic guidance
              </p>
              
              {/* Shuffle Indicator */}
              <motion.div
                className="flex justify-center items-center space-x-2 text-gray-400"
                initial={{ opacity: 0 }}
                animate={{ opacity: 1 }}
                transition={{ delay: 1, duration: 0.5 }}
              >
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
                <span className="text-sm">Cards shuffle every 15 seconds</span>
                <div className="w-2 h-2 bg-yellow-400 rounded-full animate-pulse"></div>
              </motion.div>
            </motion.div>

            {/* Simple Testimonial Cards */}
            <div className="grid md:grid-cols-3 gap-8 mb-20">
              <AnimatePresence mode="wait">
                {currentCards.map((testimonial, index) => (
                  <motion.div
                    key={`${currentCardSet}-${index}`}
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, y: -50 }}
                    transition={{ 
                      duration: 0.6,
                      delay: index * 0.1
                    }}
                    whileHover={{ 
                      y: -10,
                      transition: { duration: 0.3 }
                    }}
                    className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-2xl p-6 border border-white/20 hover:border-yellow-400/40 transition-all duration-500"
                  >
                    {/* Photo on top middle */}
                    <div className="text-center mb-6">
                      <div className="w-20 h-20 mx-auto mb-4 relative">
                        <img
                          src={testimonial.image}
                          alt={testimonial.name}
                          className="w-full h-full object-cover rounded-full border-2 border-yellow-400/60"
                        />
                      </div>
                      
                      <h4 className="text-lg font-semibold text-white mb-1">
                        {testimonial.name}
                      </h4>
                      <p className="text-purple-300 text-sm mb-3">
                        {testimonial.profession}
                      </p>
                      
                      {/* Stars */}
                      <div className="flex justify-center space-x-1 mb-4">
                        {[...Array(testimonial.stars)].map((_, i) => (
                          <span key={i} className="text-yellow-400 text-sm">⭐</span>
                        ))}
                      </div>
                    </div>

                    {/* Content below */}
                    <div className="text-center">
                      <p className="text-gray-200 leading-relaxed text-sm">
                        "{testimonial.content}"
                      </p>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>

            {/* Stats Section - Simplified */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="grid md:grid-cols-3 gap-8 mb-20"
            >
              {[
                { number: "25,000+", label: "Happy Clients", icon: "👥" },
                { number: "15+", label: "Years Experience", icon: "🌟" },
                { number: "100%", label: "Satisfaction", icon: "💫" }
              ].map((stat, index) => (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, scale: 0.9 }}
                  whileInView={{ opacity: 1, scale: 1 }}
                  transition={{ delay: index * 0.1, duration: 0.6 }}
                  whileHover={{ scale: 1.05, y: -5 }}
                  className="bg-gradient-to-br from-white/10 to-white/5 backdrop-blur-lg rounded-2xl p-6 text-center border border-white/20 hover:border-yellow-400/40 transition-all duration-500"
                >
                  <div className="text-4xl mb-3">{stat.icon}</div>
                  <div className="text-3xl font-bold text-yellow-400 mb-1">
                    {stat.number}
                  </div>
                  <div className="text-lg text-white">
                    {stat.label}
                  </div>
                </motion.div>
              ))}
            </motion.div>

            {/* CTA Section */}
            <motion.div
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.8 }}
              className="text-center"
            >
              <div className="bg-gradient-to-br from-purple-500/20 to-pink-500/20 backdrop-blur-lg rounded-3xl p-12 border border-purple-400/30">
                <h3 className="text-3xl font-bold mb-4 text-white">
                  Ready to Join Our Happy Clients?
                </h3>
                <p className="text-lg text-gray-300 mb-8 max-w-2xl mx-auto">
                  Start your journey of self-discovery and cosmic guidance today
                </p>
                <motion.button
                  whileHover={{ 
                    scale: 1.05,
                    boxShadow: "0 0 30px rgba(234, 179, 8, 0.4)",
                  }}
                  whileTap={{ scale: 0.95 }}
                  className="bg-gradient-to-r from-yellow-400 to-yellow-500 text-black px-10 py-4 rounded-full font-bold text-lg hover:from-yellow-300 hover:to-yellow-400 transition-all duration-300"
                >
                  🌟 Book Your Consultation
                </motion.button>
              </div>
            </motion.div>
          </div>
        </div>
      </motion.div>
    </CosmicBackground>
  );
};

export default Testimonials;
